module.exports = __webpack_public_path__ + "img/Ersa-VERSAFLOW366-01-900x675.c56401eb.png";